var GIFData_GIFType = /* @__PURE__ */ ((GIFData_GIFType2) => {
  GIFData_GIFType2["GIF"] = "GIF";
  GIFData_GIFType2["STICKER"] = "STICKER";
  GIFData_GIFType2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return GIFData_GIFType2;
})(GIFData_GIFType || {});
export {
  GIFData_GIFType
};
//# sourceMappingURL=plugin_gif.enums.js.map
